import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import {
    HistoricoCapitalSocialResponse,
    HistoricoCertificadoResponse,
    PrestadorCrmDisponivelResponse,
    PrestadorRenovacaoCertificadoRequest,
    PrestadorDadosGeraisRequest,
    PrestadorDadosGeraisResponse,
    PrestadorFilialResponse
} from '@/core/api/sicom-api/registro/prestador/prestador-dados-gerais.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class PrestadorDadosGeraisService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.dadosGerais;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    buscar(params: Pessoa, context?: HttpContext): Observable<PrestadorDadosGeraisResponse> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
        return this.http.get<PrestadorDadosGeraisResponse>(this.PATH, { params: httpParams, context });
    }

    atualizar(body: PrestadorDadosGeraisRequest, context?: HttpContext): Observable<PrestadorDadosGeraisResponse> {
        return this.http.put<PrestadorDadosGeraisResponse>(this.PATH, body, { context });
    }

    verificarCrmDisponivel(params: Pessoa & { crm: string }, context?: HttpContext): Observable<PrestadorCrmDisponivelResponse> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf)).set('crm', params.crm);
        return this.http.get<PrestadorCrmDisponivelResponse>(`${this.PATH}/crm-disponivel`, { params: httpParams, context });
    }

    listarFiliais(params: Pessoa, context?: HttpContext): Observable<PrestadorFilialResponse[]> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
        return this.http.get<PrestadorFilialResponse[]>(`${this.PATH}/filiais`, { params: httpParams, context });
    }

    listarHistoricoCapitalSocial(params: Pessoa, tipo: 'P' | 'M', context?: HttpContext): Observable<HistoricoCapitalSocialResponse[]> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf)).set('tipo', tipo);
        return this.http.get<HistoricoCapitalSocialResponse[]>(`${this.PATH}/capital-social/historico`, { params: httpParams, context });
    }

    listarHistoricoCertificado(params: Pessoa, context?: HttpContext): Observable<HistoricoCertificadoResponse[]> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
        return this.http.get<HistoricoCertificadoResponse[]>(`${this.PATH}/certificado/historico`, { params: httpParams, context });
    }

    renovarCertificado(request: PrestadorRenovacaoCertificadoRequest, context?: HttpContext): Observable<void> {
        return this.http.post<void>(`${this.PATH}/certificado/renovar`, request, { context });
    }

    zerarFiliais(params: Pessoa, context?: HttpContext): Observable<void> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
        return this.http.patch<void>(`${this.PATH}/zerar-filiais`, null, { params: httpParams, context });
    }
}
